import React from 'react';
import Icon from "./Icon";
import PropTypes from "prop-types";

const InstagramIcon = (props) => {
    return (
        <div className='listing-footer__icon-block' onClick={props.onClick}>
            <Icon
                className='text-white'
                icon='icon-instagram'
                selected={props.selected}
            />
        </div>
    );
}

InstagramIcon.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func,
}

InstagramIcon.defaultProps = {
    selected: false,
    onClick: () => {}
}

export default InstagramIcon;
